<template>
  <div class="task-item-left-row">
    <div class="row-left"><b>任务类型：</b>{{ record.dn }}</div>
    <div class="row-right">
      <span v-if="record.isManual">手动创建</span><span v-else>定时任务</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "record-info",
  props: ["record"],
};
</script>

<style lang="less" scoped>
@row-height: 22px;
@item-padding: 4px;
@item-height: @row-height * 3;
//@right-width: 60px;
@right-width: 10px;
@row-right-width: 60px;
.task-item-left-row {
  position: relative;
  height: @row-height;
  line-height: @row-height;
  white-space: nowrap;
  .row-left {
    margin-right: @row-right-width;
    height: @row-height;
    overflow: hidden;
    b:nth-of-type(n + 2) {
      margin-left: 40px;
    }
  }
  .row-right {
    text-align: right;
    position: absolute;
    top: 0;
    right: 0;
    height: @row-height;
    width: @row-right-width;
  }
}
</style>
